'use es6';

import Immutable from 'immutable';
import * as SearchTypes from '../enums/SearchTypes';
const getFileSearchType = ({
  systemRecognizedFileExtension,
  searchQuery,
  fileTypeFilterValue
} = {}) => {
  let searchCriteria = Immutable.List();
  if (searchQuery && searchQuery.length > 0) {
    searchCriteria = searchCriteria.push('KEYWORDS');
  }
  if (systemRecognizedFileExtension) {
    searchCriteria = searchCriteria.push('EXTENSION');
  }
  if (fileTypeFilterValue) {
    searchCriteria = searchCriteria.push('FILETYPE');
  }
  if (searchCriteria.isEmpty()) {
    return SearchTypes.KEYWORDS;
  }
  return searchCriteria.join('_');
};
export default getFileSearchType;